"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBTextArea = exports.IMBTextAreaVariant = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_i18next_1 = require("react-i18next");
var WarningCircleIcon_1 = require("../Icons/WarningCircleIcon");
var validations_1 = require("../../utils/validations");
var mock_1 = require("../../utils/mock");
var themes_1 = require("../../themes");
var array_1 = require("../../utils/array");
var IMBTextAreaVariant;
(function (IMBTextAreaVariant) {
    IMBTextAreaVariant[IMBTextAreaVariant["large"] = 0] = "large";
    IMBTextAreaVariant[IMBTextAreaVariant["medium"] = 1] = "medium";
    IMBTextAreaVariant[IMBTextAreaVariant["small"] = 2] = "small";
})(IMBTextAreaVariant = exports.IMBTextAreaVariant || (exports.IMBTextAreaVariant = {}));
/**
 * MBTextArea
 * ===
 * @description Meetbutter's custom input designed according to Verse UI kit
 *
 * errorMsg
 * ---
 * @description attach this error string to manage error state yourself (i18n translated)
 *
 * errors
 * ---
 * @description attach this error object from useForm in react-hook-form to manage error states. Use clearError() to clear errors
 */
exports.MBTextArea = react_1.forwardRef(function (_a, ref) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, onChange = _a.onChange, value = _a.value, _c = _a.placeholder, placeholder = _c === void 0 ? 'placeholder' : _c, placeholderTVal = _a.placeholderTVal, _d = _a.variant, variant = _d === void 0 ? IMBTextAreaVariant.medium : _d, _e = _a.width, width = _e === void 0 ? '100%' : _e, border = _a.border, _f = _a.type, type = _f === void 0 ? 'text' : _f, disabledStyles = _a.disabledStyles, maxLength = _a.maxLength, boxProps = _a.boxProps, disableDisabledStyles = _a.disableDisabledStyles, name = _a.name, defaultValue = _a.defaultValue, errorMsg = _a.errorMsg, errorMsgTVal = _a.errorMsgTVal, errors = _a.errors, autoFocus = _a.autoFocus, autoComplete = _a.autoComplete, bgcolor = _a.bgcolor, color = _a.color, padding = _a.padding, hover = _a.hover, cols = _a.cols, _g = _a.rows, rows = _g === void 0 ? 4 : _g, extraComponent = _a.extraComponent, onBlur = _a.onBlur, onFocus = _a.onFocus;
    var _h = __read(react_1.useState(false), 2), tooltipOpen = _h[0], setTooltipOpen = _h[1];
    var intRef = react_1.useRef(null);
    var t = react_i18next_1.useTranslation().t;
    var handleClose = function () {
        setTooltipOpen(false);
    };
    var handleOpen = function () {
        setTooltipOpen(true);
        clearTimeout(intRef.current);
    };
    var errorToUse = react_1.useMemo(function () {
        if (errorMsg) {
            return typeof errorMsg === 'string'
                ? t(errorMsg, errorMsgTVal)
                : errorMsg;
        }
        var filteredError = array_1.objToArray(errors).find(function (eachObj) { return eachObj.key === name; });
        if (filteredError && (filteredError === null || filteredError === void 0 ? void 0 : filteredError.type) !== validations_1.ValidateState.validated) {
            return filteredError === null || filteredError === void 0 ? void 0 : filteredError.message;
        }
        return null;
    }, [errors, errorMsg, errorMsgTVal, name, t]);
    react_1.useEffect(function () {
        if (errorToUse) {
            clearTimeout(intRef.current);
            handleOpen();
            intRef.current = setTimeout(function () {
                handleClose();
            }, 3500);
        }
    }, [errorToUse]);
    return (jsx_runtime_1.jsxs(core_1.Box, __assign({ position: "relative", width: width, display: "flex" }, boxProps, { children: [errorToUse && (jsx_runtime_1.jsx(core_1.Box, __assign({ position: "absolute", right: 13, height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }, { children: jsx_runtime_1.jsx(StyledTooltip, __assign({ open: tooltipOpen, onClose: handleClose, onOpen: handleOpen, title: errorToUse, placement: "top" }, { children: jsx_runtime_1.jsx(core_1.Box, { children: jsx_runtime_1.jsx(WarningCircleIcon_1.WarningCircleIcon, { size: 16, stroke: themes_1.THEME.colors.danger.Red100 }, void 0) }, void 0) }), void 0) }), void 0)), extraComponent, jsx_runtime_1.jsx(StyledInput, { inputRef: ref, width: width, disabled: disabled, onChange: onChange, value: value, variant: variant, placeholder: t(placeholder, placeholderTVal), errorMsg: errorToUse, border: border, disabledStyles: disabledStyles, type: type, maxLength: maxLength, disableDisabledStyles: disableDisabledStyles, name: name, defaultValue: defaultValue, autoFocus: autoFocus, autoComplete: autoComplete, bgcolor: bgcolor, padding: padding, rows: rows, cols: cols, color: color, hover: hover, onFocus: onFocus, onBlur: onBlur }, void 0)] }), void 0));
});
var StyledInput = styled_components_1.default(function (_a) {
    var variant = _a.variant, errorMsg = _a.errorMsg, inputRef = _a.inputRef, disabledStyles = _a.disabledStyles, disableDisabledStyles = _a.disableDisabledStyles, bgcolor = _a.bgcolor, color = _a.color, hover = _a.hover, padding = _a.padding, rest = __rest(_a, ["variant", "errorMsg", "inputRef", "disabledStyles", "disableDisabledStyles", "bgcolor", "color", "hover", "padding"]);
    mock_1.mockFunction({
        variant: variant,
        errorMsg: errorMsg,
        disabledStyles: disabledStyles,
        disableDisabledStyles: disableDisabledStyles,
        bgcolor: bgcolor,
        color: color,
        hover: hover,
        padding: padding,
    });
    return jsx_runtime_1.jsx("textarea", __assign({}, rest, { ref: inputRef }), void 0);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    border-radius: 4px;\n    transition: 0.2s all ease-in-out;\n    width: 100%;\n    color: ", ";\n\n    :hover {\n      ", "\n    }\n\n    ", "\n\n    ::placeholder {\n      color: ", ";\n    }\n    :focus {\n      background-color: ", ";\n    }\n\n    border: ", ";\n\n    background-color: ", ";\n\n    ", "\n    ", "\n  }\n"], ["\n  && {\n    border-radius: 4px;\n    transition: 0.2s all ease-in-out;\n    width: 100%;\n    color: ", ";\n\n    :hover {\n      ",
    "\n    }\n\n    ",
    "\n\n    ::placeholder {\n      color: ", ";\n    }\n    :focus {\n      background-color: ",
    ";\n    }\n\n    border: ",
    ";\n\n    background-color: ",
    ";\n\n    ",
    "\n    ", "\n  }\n"])), function (_a) {
    var color = _a.color, theme = _a.theme;
    return (color ? color : theme.colors.basic.Black);
}, function (_a) {
    var hover = _a.hover, theme = _a.theme;
    return hover ? hover : "background-color: " + theme.colors.basic.DimWhite + ";";
}, function (_a) {
    var disableDisabledStyles = _a.disableDisabledStyles, theme = _a.theme, disabledStyles = _a.disabledStyles;
    return !disableDisabledStyles &&
        "\n          :disabled {\n            background-color: " + theme.colors.basic.Grey05 + ";\n            border-color: " + theme.colors.basic.Grey30 + ";\n            color: " + theme.colors.basic.Grey30 + ";\n            " + disabledStyles + "\n          }\n      ";
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.basic.Grey30;
}, function (_a) {
    var theme = _a.theme, bgcolor = _a.bgcolor;
    return bgcolor ? bgcolor : theme.colors.basic.White100;
}, function (_a) {
    var theme = _a.theme, errorMsg = _a.errorMsg, border = _a.border;
    return border
        ? border
        : "1px solid " + (errorMsg ? theme.colors.danger.Red100 : theme.colors.basic.Black);
}, function (_a) {
    var theme = _a.theme, errorMsg = _a.errorMsg, bgcolor = _a.bgcolor;
    return errorMsg
        ? "" + theme.colors.danger.Red25
        : bgcolor
            ? bgcolor
            : "" + theme.colors.basic.White100;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    switch (variant) {
        case IMBTextAreaVariant.small:
            return "\n              padding: 8px 12px; \n              " + theme.typography.label + "\n            ";
        case IMBTextAreaVariant.medium:
            return "\n              padding: 11px 16px; \n              " + theme.typography.body3 + "\n            ";
        case IMBTextAreaVariant.large:
            return "\n              padding: 14px 16px;\n              " + theme.typography.body2 + "\n            ";
        default:
            return "";
    }
}, function (_a) {
    var padding = _a.padding;
    return padding && "padding: " + padding + ";";
});
var StyledTooltip = styles_1.withStyles({
    tooltip: {
        backgroundColor: themes_1.THEME.colors.danger.Red50,
        border: "1px solid " + themes_1.THEME.colors.danger.Red100,
        color: themes_1.THEME.colors.basic.Black,
        maxWidth: 220,
        boxShadow: '0px 4px 14px rgba(12, 43, 84, 0.2)',
        fontSize: 14,
        textAlign: 'center',
    },
})(core_1.Tooltip);
var templateObject_1;
//# sourceMappingURL=MBTextArea.js.map